import { gql } from '@reverbdotcom/commons/src/gql';
import React from 'react';
import className from 'classnames';
import { displayPaymentMethod } from '../lib/payment_method_icons';
import { PaymentMethodIcons } from './PaymentMethodIcons';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
  core_apimessages_Error as Error,
} from '@reverbdotcom/commons/src/gql/graphql';

import { useExpEnabled, useUser } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { trackBuyNowOptionClick } from './checkout/buyNowTracking';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';

interface Props {
  listingId: string;
  paymentMethod: CheckoutPaymentMethodType;
  onSuccess: (redirectUrl: string, paymentMethodType: CheckoutPaymentMethodType) => any;
  onError: (errors: Error[]) => any;
  setLoading: (loading: boolean) => any;
  disabled: boolean;
  quantity: number;
}

export function BuyItNowStandardOption(props: Props) {
  const user = useUser();

  const [mutate] = useMutation(START_CHECKOUT_FOR_LISTING, {
    onError: props.onError,
  });

  const standalonePayPalExp = useExpEnabled(experiments.STANDALONE_PAYPAL_BIN) && props.paymentMethod === CheckoutPaymentMethodType.PAYPAL;
  const displayKey = standalonePayPalExp ? 'standalone_paypal' : props.paymentMethod;
  const display = displayPaymentMethod(displayKey);

  async function onClickPaymentMethod() {
    trackBuyNowOptionClick({
      listingId: props.listingId,
      paymentMethod: props.paymentMethod,
      user,
    });

    props.setLoading(true);

    try {
      const result = await mutate({
        variables: {
          input: {
            listingId: props.listingId,
            paymentMethod: props.paymentMethod,
            quantity: props.quantity,
          },
        },
      });

      const redirectUrl = result?.data?.startCheckoutForListing?.redirectUrl;

      if (redirectUrl) {
        props.onSuccess(redirectUrl, props.paymentMethod);
      }
    } catch {
      props.setLoading(false);
    }
  }

  const buttonClasses = className(
    'buy-it-now-standard-option',
    { 'buy-it-now-standard-option--dc': props.paymentMethod === CheckoutPaymentMethodType.DIRECT_CHECKOUT },
  );

  if (!display || props.disabled) {
    return null;
  }

  return (
    <button
      onClick={onClickPaymentMethod}
      type="button"
      className={buttonClasses}
    >
      <div className="buy-it-now-standard-option__title">
        <h3>{display.title}</h3>
      </div>
      <div className="buy-it-now-standard-option__icons">
        <PaymentMethodIcons icons={display.icons} />
      </div>
    </button>
  );
}

const START_CHECKOUT_FOR_LISTING = gql(`
  mutation StartCheckoutForListing($input: Input_core_apimessages_StartCheckoutForListingRequest) {
    startCheckoutForListing(input: $input) {
      redirectUrl
    }
  }
`);
